import Cookies from 'cookie-universal'

export function getFbCookies(): { fbc?: string; fbp?: string } {
  const cookies = Cookies()
  const fbc = cookies.get('_fbc')
  const fbp = cookies.get('_fbp')
  return {
    ...(fbc ? { fbc } : {}),
    ...(fbp ? { fbp } : {}),
  }
}
